module.exports = __webpack_public_path__ + "static/leaves-3cd889b67c54dd4d4b487c936738df31.png";